/*
 * recently-viewed.js — "Your browsing history". Records each product the shopper
 * opens into localStorage (per device), then renders a strip of the most recent ones
 * on the product page (excluding the current product). Cards are built from each
 * product's /products/<handle>.js JSON so no extra template is needed.
 *
 * Note: this is device-local (localStorage). Cross-device history "from the login"
 * would need a server-side store keyed to the customer — a backend follow-up.
 */
(function () {
  var KEY = 'bib_recently_viewed';
  var MAX_STORE = 16;   // how many handles we remember
  var MAX_SHOW = 10;    // how many we render on the PDP

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX_STORE))); } catch (e) {} }

  var root = document.querySelector('[data-recently-viewed]');
  var current = root ? root.getAttribute('data-current') : null;

  // 1) Record the current product (most-recent first, de-duped).
  if (current) {
    var list = read().filter(function (h) { return h && h !== current; });
    list.unshift(current);
    write(list);
  }

  if (!root) return;

  // 2) Render the history (minus the current product).
  var handles = read().filter(function (h) { return h && h !== current; }).slice(0, MAX_SHOW);
  if (!handles.length) return;

  var track = root.querySelector('[data-rvw-track]');

  function inr(cents) {
    try { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }
    catch (e) { return '₹' + Math.round(cents / 100); }
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  Promise.all(handles.map(function (h) {
    return fetch('/products/' + encodeURIComponent(h) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  })).then(function (items) {
    var frag = document.createDocumentFragment();
    var shown = 0;
    items.forEach(function (p) {
      if (!p) return;
      shown++;
      var a = document.createElement('a');
      a.className = 'rvw__card';
      a.href = p.url || ('/products/' + p.handle);
      var img = sized(p.featured_image || (p.images && p.images[0]) || '', 300);
      a.innerHTML =
        '<div class="rvw__img">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</div>' +
        '<div class="rvw__name">' + (p.title || '') + '</div>' +
        '<div class="rvw__price">' + (typeof p.price === 'number' ? inr(p.price) : '') + '</div>';
      frag.appendChild(a);
    });
    if (shown) { track.appendChild(frag); root.hidden = false; }
  });
})();
